import { render } from "./MdSuggestionChip.vue?vue&type=template&id=31adfa2c&scoped=true&ts=true"
import script from "./MdSuggestionChip.vue?vue&type=script&lang=ts"
export * from "./MdSuggestionChip.vue?vue&type=script&lang=ts"

import "./MdSuggestionChip.vue?vue&type=style&index=0&id=31adfa2c&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31adfa2c"]])

export default __exports__